import Link from "next/link";
import React from "react";
import { useRouter } from "next/router";
import { ROUTES } from "../../routes/Routes";

const NavLink = ({ path, value }) => {
  const router = useRouter();
  const { asPath } = router;
  const root = asPath.split("/")[1] || "";
  const basePath = path.split("/")[1];

  let selected = root === basePath && !path.includes("https");

  let className = "px-6 py-2 flex items-center rounded-full cursor-pointer ";
  className += "hover:bg-primary hover:text-white dark:text-white ";
  className += selected ? "bg-primary text-white" : "text-black";

  return (
    <Link href={path}>
      <div className={className}>
        <a target={path.includes("https") ? "_blank" : "_self"}>
          <div className="flex flex-row items-center">
            <span className="ml-4 font-semibold">{value}</span>
          </div>
        </a>
      </div>
    </Link>
  );
};

const NavBar = () => {
  return (
    <nav className="py-4 px-6 space-y-4">
      {ROUTES.map((r, idx: number) => <NavLink {...r} key={idx} />)}
    </nav>
  )
}

export default NavBar
